import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import IntlMessageFormat from "intl-messageformat";
import { useStringMap } from "../../utilities/string-map/useStringMap";
import { useCallbackRef } from "../../hooks/useCallbackRef";
import * as Styled from "./CharacterCount.styled";
import { useCharacterCount } from "./useCharacterCount";
import { stringMapDefault } from "./CharacterCount.stringMap";
const componentName = "CharacterCount";
export const CharacterCount = ({ id, elementRef, isRelativeToParent, maxLength = 0, isLive, offsetRight, onCharacterCount, onMaxLengthStatusChange, 
// Placeholder text needs to be passed for non input fields to calculate the character count accurately
excludedTextContent, stringMap: stringMapProp }) => {
    const stringMap = useStringMap(componentName, { stringMapDefault, stringMapProp });
    const { characterCount, screenReaderCharacterCount } = useCharacterCount(elementRef, excludedTextContent);
    const isValid = characterCount <= maxLength;
    const callbackRef = useCallbackRef(onMaxLengthStatusChange);
    const onCharacterCountCallbackRef = useCallbackRef(onCharacterCount);
    useEffect(() => {
        callbackRef.current?.(isValid);
    }, [callbackRef, isValid]);
    useEffect(() => {
        onCharacterCountCallbackRef.current?.({
            characterCount,
            maxLength,
            remainingCharacters: maxLength - characterCount
        });
    }, [characterCount, maxLength, onCharacterCountCallbackRef]);
    const characterCountString = typeof stringMap.characterCount === "function"
        ? stringMap.characterCount({ maxLength, characterCount })
        : new IntlMessageFormat(stringMap.characterCount).format({
            characterCount: screenReaderCharacterCount,
            maxLength
        });
    const maxLengthString = typeof stringMap.maxLength === "function"
        ? stringMap.maxLength(maxLength)
        : new IntlMessageFormat(stringMap.maxLength).format({ maxLength });
    return (_jsxs(_Fragment, { children: [_jsx(Styled.CharacterCountWrapper, { "data-testid": "CharacterCount", "aria-hidden": "true", isRelativeToParent: isRelativeToParent, isValid: isValid, offsetRight: offsetRight, tabIndex: -1, children: `${characterCount} / ${maxLength}` }), isLive && (_jsx(Styled.ScreenReaderCharacterCount, { role: "status", "aria-live": "polite", children: characterCountString })), _jsx(Styled.ScreenReaderCharacterCount, { id: id, children: maxLengthString })] }));
};
CharacterCount.displayName = componentName;
